import Box from "@mui/material/Box";
import { HashLink } from "react-router-hash-link";
import { useTranslation } from "react-i18next";

import React from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { ScrollMenu, VisibilityContext } from "react-horizontal-scrolling-menu";
import Fade from "react-reveal/Fade";
import Flip from "react-reveal/Flip";
import CurrencyFormat from "react-currency-format";

const getItems = () =>
  Array(20)
    .fill(0)
    .map((_, ind) => ({ id: `element-${ind}` }));

function App({ products, currentLocation }) {
  // console.log("scroll currentLocation", currentLocation);
  // console.log(products);
  let items = Array(products.length)
    .fill(0)
    .map((_, ind) => ({ id: `element-${ind}`, ...products[ind] }));

  // const [items, setItems] = React.useState(getItems);
  const [selected, setSelected] = React.useState([]);

  const isItemSelected = (id) => !!selected.find((el) => el === id);

  const handleClick =
    (id) =>
    ({ getItemById, scrollToItem }) => {
      const itemSelected = isItemSelected(id);

      setSelected((currentSelected) =>
        itemSelected
          ? currentSelected.filter((el) => el !== id)
          : currentSelected.concat(id)
      );
    };

  return (
    <ScrollMenu LeftArrow={LeftArrow} RightArrow={RightArrow}>
      {items.map((pro, idx) => {
        return (
          <Card
            currentLocation={currentLocation}
            itemId={pro.id} // NOTE: itemId is required for track items
            title={pro.id}
            key={pro.id}
            onClick={handleClick(pro.id)}
            selected={isItemSelected(pro.id)}
            pro={pro}
            // pro={products}
          />
        );
      })}
    </ScrollMenu>
  );
}

function LeftArrow() {
  const { isFirstItemVisible, scrollPrev } =
    React.useContext(VisibilityContext);

  return (
    <ArrowBackIcon
      disabled={isFirstItemVisible}
      onClick={() => scrollPrev()}
      style={{ position: "relative", top: "120px", cursor: "pointer" }}
    />
  );
}

function RightArrow() {
  const { isLastItemVisible, scrollNext } = React.useContext(VisibilityContext);

  return (
    <ArrowForwardIcon
      disabled={isLastItemVisible}
      onClick={() => scrollNext()}
      style={{ position: "relative", top: "120px", cursor: "pointer" }}
    />
  );
}

function Card({ onClick, selected, title, itemId, pro, currentLocation }) {
  const { t, i18n } = useTranslation();
  const visibility = React.useContext(VisibilityContext);
  // console.log("pro", pro);

  return (
    <div
      onClick={() => onClick(visibility)}
      style={{
        width: "200px",
        marginRight: "20px",
        paddingTop: "20px",
        paddingBottom: "20px",
      }}
      tabIndex={0}
    >
      <div className="card">
        {/* <div>{title}</div>
        <div>visible: {JSON.stringify(!!visibility.isItemVisible(itemId))}</div>
        <div>selected: {JSON.stringify(!!selected)}</div> */}

        <Box sx={{ textAlign: "center" }}>
          <Box
            sx={{
              backgroundColor: "#f8f7f5",
              width: "170px",
              my: 2,
              mx: 1,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <HashLink to={"/product/" + pro.linkTo + "#top"}>
              <img
                src={pro.img}
                width="100"
                height="120"
                className="animation"
                style={{
                  cursor: "pointer",
                  marginTop: "3px",
                  marginBottom: "3px",
                }}
              />
            </HashLink>
          </Box>
          <Box
            sx={{
              mt: 2,
              position: "relative",
              minHeight: "70px",
              textAlign: "center",
              width: 1,
            }}
          >
            <HashLink to={"/product/" + pro.linkTo + "#top"}>
              <Box sx={{ mb: 2, fontSize: "13px" }}>{t(pro.title)}</Box>
              {/* <Box sx={{ position: "absolute", bottom: 0, left: 55 }}> */}
              <span class="outer">
                <span class="inner">
                  {currentLocation === "KO" ? (
                    <CurrencyFormat
                      value={+pro.price_KO / 0.8}
                      displayType={"text"}
                      thousandSeparator={true}
                      suffix={"원"}
                    />
                  ) : (
                    <CurrencyFormat
                      value={pro.price_US + 1}
                      displayType={"text"}
                      thousandSeparator={true}
                      prefix={"$"}
                    />
                  )}
                </span>
              </span>
              &nbsp;
              <span style={{ color: "#6b90db", fontSize: "16px" }}>
                {currentLocation === "KO" ? (
                  <CurrencyFormat
                    value={pro.price_KO}
                    displayType={"text"}
                    thousandSeparator={true}
                    suffix={"원"}
                  />
                ) : (
                  <CurrencyFormat
                    value={pro.price_US}
                    displayType={"text"}
                    thousandSeparator={true}
                    prefix={"$"}
                  />
                )}
              </span>
              {/* </Box> */}
            </HashLink>
          </Box>
        </Box>
      </div>
      <div
        style={{
          height: "20px",
        }}
      />
    </div>
  );
}

export default App;
